export const EV_SESSION_STATUS: {Key: number, Name: string, Display: string}[] = [
    { Key: 0, Name: 'Unknown', Display: 'i18n:VIEW_STATIC_LIST.EV_SESSION_STATUS.UNKNOWN' },
    { Key: 1, Name: 'Active', Display: 'i18n:VIEW_STATIC_LIST.EV_SESSION_STATUS.ACTIVE' },
    { Key: 2, Name: 'Complete', Display: 'i18n:VIEW_STATIC_LIST.EV_SESSION_STATUS.COMPLETE' }];
